import { useTheme } from '@mui/material';
import { ResponsivePie } from '@nivo/pie';
import { tokens } from 'theme/tokens';
import { CHART_COLORS } from 'utils/constant';

const PieChart = ({
  data,
  customColor,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <ResponsivePie
      data={data}
      margin={{right: 20, bottom: 20, left: 20 }}
      innerRadius={0.5}
      padAngle={0.7}
      cornerRadius={3}
      activeOuterRadiusOffset={8}
      colors={customColor ? ({ id }) => CHART_COLORS[id] : [colors.indigo[400], colors.green[400], colors.blue[400], colors.red[400]]}
      enableArcLinkLabels={false}
      enableArcLabels={false}
      arcLabelsSkipAngle={10}
      arcLabelsTextColor={{ from: 'color', modifiers: [['darker', 2]]}}
    />
  )
}

export default PieChart;